<div class="dialog-root" role="dialog" aria-modal="true">
  <button class="close-btn" aria-label="Close" (click)="close()">
    <span>&#x2715;</span>
  </button>

  <h2 class="title">Redeem Balance</h2>
  <p class="subtitle">Enter the amount you’d like to redeem from your available tokens</p>

  <div class="amount-input">
    <input
      type="text"
      placeholder="Enter Amount"
      [(ngModel)]="amount"
      [disabled]="loading || isSubmitting"
    />
  </div>

  <div class="refund-section" *ngIf="!loading; else loadingTpl">
    <div class="section-title">Refund Source</div>

    <div class="source-list" *ngIf="sources?.length; else noSourcesTpl">
      <div class="source-item" *ngFor="let s of sources">
        <div class="left">
          <div class="icon-box">
            <span class="icon-wallet">&#128179;</span>
          </div>
          <div class="meta">
            <div class="label">{{ s.label }}</div>
            <div class="desc">{{ s.display || s.value }}</div>
          </div>
        </div>

        <div class="right">
          <button class="select-radio" [class.active]="selectedId === s.id" (click)="selectSource(s.id)">
            <span class="inner"></span>
          </button>
        </div>
      </div>

      <!-- <div class="source-item add-new" (click)="openAddNew()">
        <div class="left">
          <div class="icon-box plus">＋</div>
          <div class="meta">
            <div class="label">Add New</div>
          </div>
        </div>
      </div> -->
    </div>

    <ng-template #noSourcesTpl>
      <div class="no-sources">
        No refund source configured for your account. <span class="add-inline" (click)="openAddNew()">Add one now</span>.
      </div>
    </ng-template>
  </div>

  <ng-template #loadingTpl>
    <div class="loading">Loading refund source…</div>
  </ng-template>

  <div class="actions">
    <button class="redeem-btn" (click)="redeem()" [disabled]="isSubmitting || loading">
      <span *ngIf="!isSubmitting">Redeem</span>
      <span *ngIf="isSubmitting">Processing…</span>
    </button>
  </div>
</div>
